:host {
  --ux-button-font-weight: normal;
  --ux-button-text-transform: initial;
  --ux-font: "Frutiger-Light", sans-serif;
  --ux-button-text-color: #131313;
  --ux-button-font-size: 16px;
}

slot[name="on"],
slot[name="off"] {
  display: none;
}

:host([on]) {
  slot[name="on"] {
    display: block;
  }
}

:host([off]) {
  slot[name="off"] {
    display: block;
  }
}
